import React from "react";

function autoEnabled({id = ''}){
  return (
   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M11.75 22.75C17.8251 22.75 22.75 17.8251 22.75 11.75C22.75 5.67487 17.8251 0.75 11.75 0.75C5.67487 0.75 0.75 5.67487 0.75 11.75C0.75 17.8251 5.67487 22.75 11.75 22.75Z" stroke="url(#paint0_linear_5342_59531)" stroke-width="1.5"/>
  <path d="M7.75 16.25L9.34412 11.8662M9.34412 11.8662L11.2671 6.57792C11.4261 6.14069 12.0445 6.14069 12.2035 6.57792L14.1265 11.8662M9.34412 11.8662H14.1265M14.1265 11.8662L15.7206 16.25" stroke="url(#paint1_linear_5342_59531)" stroke-width="1.5" stroke-linecap="round"/>
  <defs>
    <linearGradient id="paint0_linear_5342_59531" x1="0.897512" y1="0.110176" x2="0.897512" y2="36.3432" gradientUnits="userSpaceOnUse">
      <stop stop-color="#01B5DE"/>
      <stop offset="0.653846" stop-color="#F37320"/>
    </linearGradient>
    <linearGradient id="paint1_linear_5342_59531" x1="7.80344" y1="5.95917" x2="7.80344" y2="22.4287" gradientUnits="userSpaceOnUse">
      <stop stop-color="#01B5DE"/>
      <stop offset="0.653846" stop-color="#F37320"/>
    </linearGradient>
  </defs>
</svg>
  )
}
export default autoEnabled;